import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const WebinarPage = React.lazy(() => import('./Webinar'));

function Webinar(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>وبینار</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <WebinarPage {...props} />
      </Suspense>
    </Page>
  );
}

export default Webinar;
